import React, { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import { tab } from "@testing-library/user-event/dist/tab";


function InvoiceSplit(props)
{

    
    
    
    const [view, setView] = useState('btn');
 
    const [row, setRow] = useState( props.selected );
    const [isStarted, setIsStarted] = useState(0);


 


    const goApproveById = (idFaktury) => {


        var ids = new Array();
    

        ids.push({
            id: idFaktury,
            title: 'Rozliczenie'
        });
 


        props.mainView.setProgress(-2);

        var req = {
            ids: ids,                        
        }


        fetch( Config.master + '/rest_v1_calc,calc_clear', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
 
                        if(res.status == 'OK') //zatwierdzono prawidlowo.. mozna wystawiac kolejny..
                        {
                       

                            for(var k=0;k<row.length; k++)
                                {
                                    if(row[k].status == 1 && row[k].id == idFaktury) //na gotowe..
                                    {                                        
                                        row[k].status = 2; //gotowe
                                        if(props.onSuccess != undefined) props.onSuccess();
                                        break;
                                    }
                                }                        
                                setRow( JSON.parse( JSON.stringify(row) ) );
                                goCreate();
                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Spróbuj ponownie za chwilę.' , "ok" , null);    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }


    


    const goCreate = () => {



        //znajdz kolejne ID oczekujace na wystawienie...
        var findId = -1;

        for(var k=0;k<row.length; k++)
        {
            if(row[k].status == 0 || row[k].status == undefined  ) //oczekuje..
            {
                findId = row[k].id; 
                row[k].status = 1; //ustaw czekaj...
                break;
            }
        }

        setRow( JSON.parse( JSON.stringify(row) ) );

        if(findId > -1)
        {
            goApproveById(findId);
        }

    }

    const startX = () => {

        if(isStarted == 1) return;

        setIsStarted(1);
        goCreate();
    }
    

 

    const showDlg = () => {
    
         setView("dlg");   
    }     

    const closeDlg = () => {
        setView("btn");  
        setIsStarted(0); 
   }  
 
    var itemsTN = [
        { v: '0', title: 'Nie - rodzice nie mogą płacić szybkim przelewem' }, 
        { v: '1', title: 'Tak - rodzice mogą płacić szybkim przelewem' }, 
    ];



    if(row == null)
    {
        setRow([]); 
        return <span>...</span>
    }


    var progress = null;
    var gotowych = 0;

    for(var k=0;k<row.length; k++)
        {
            if(row[k].status == 2) //oczekuje..
            {
                gotowych++;
            }
        }

    var proc =  parseInt( (100 * gotowych) / row.length);
    
    if(gotowych > 0) 
    {
        progress = <div><strong>Postęp {proc} % </strong></div>;
    }

    



    if(row.length != props.selected.length)
    {
        setRow(props.selected);
    }



    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Usunięcie przypisanych pozycji - Zerowanie kwoty rozliczenia
                    </div>


                    <div className="dlg_content_x">


                                   

                                  

                                    <br/>

                                    <div className="form_tab">

                                    <div>
                                        Wybrane dokumenty: {row.length} 
                                    </div>

                                    {progress}
 
                                    <div className="bg_center scroll150 nostick">                                            

                                            <table className="table" >
                                                    <thead>
                                                    <tr className="header">                                                                                  
                                                        <td>LP</td>                                                                                                                                
                                                        <td>Opis</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Kwota</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Kwota rozliczenia</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                        <td>Status</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        row.map( (item, ix) => {

                                                            var st = item.status;
                                                            if(item.status == 0 || item.status == undefined ) st = "---";
                                                            if(item.status == 1) st = "Czekaj...";
                                                            if(item.status == 2) st = "Gotowe!";
                                                            if(item.status == 3) st = "Błąd!";

                                                            return <tr>
                                                                <td className="gocenter">{ix+1}</td>                                                                                                                                
                                                                <td className="goleft">{item.title}</td> 
                                                                <td className="goright">{item.kwota}</td> 
                                                                <td className="goright">{item.kwota_rozliczenia}</td> 
                                                                <td className="gocenter" >{st}</td>  
                                                            </tr>
                                                        })

                                                    }
                                                </tbody>
                                            </table>

                                        </div>
  

                                        <div className="form_split"></div>
                                        <br/>
                                        <div className="form_split"></div>

                                        <div className="form_control">      
                                            {
                                                isStarted == 0 &&
                                                <Fragment>
                                                    <div className="btn" onClick={startX}>wyzeruj kwotę rozliczenia</div>                                                  
                                                </Fragment>                                                
                                            }                                                                                  
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={closeDlg}>zamknij</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;

    

    return  <React.Fragment>
                <div className="btn"    onClick={showDlg} >Odepnij przypisane / Wyzeruj kwotę rozliczenia</div> 
                {dlg_view} 
           </React.Fragment>
}


export default InvoiceSplit;